// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore'; // Si vas a usar Firestore

// Tus credenciales de configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAZ8kB_vFI-Qs99j1GZitX35BkQXAW8zqA",
  authDomain: "ir-tracking-1e7ec.firebaseapp.com",
  projectId: "ir-tracking-1e7ec",
  storageBucket: "ir-tracking-1e7ec.firebasestorage.app",
  messagingSenderId: "294862674886",
  appId: "1:294862674886:web:52cd72e9ac80e4dca830c7"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Exporta servicios que vas a usar
export const auth = getAuth(app);
export const db = getFirestore(app); // Exporta Firestore si lo usas